/**
 * relivConferenceDscMenuButton
 */
angular.module('relivConference').directive(
    'relivConferenceDscMenuButton',
    [
        'relivConferenceDscMenu',
        function (
            relivConferenceDscMenu
        ) {
            /**
             * Link function
             *
             * @param scope
             * @param element
             * @param attrs
             */
            function link(scope, element, attrs) {
                scope.handleClick = function () {
                    relivConferenceDscMenu.displayToggle();
                };
            }

            return {
                link: link,
                scope: {
                    propButtonLabel: '=buttonLabel', // string
                },
                template: '' +
                '<button class="btn btn-default btn-sm" ng-click="handleClick()">' +
                ' {{propButtonLabel}}' +
                '</button>',
            };
        },
    ]
);
